// paymentProfileForm
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD'
export const SET_PAYMENT_PROFILE_FORM = 'SET_PAYMENT_PROFILE_FORM'
